import { render } from "./OpenHead.vue?vue&type=template&id=57e547bc&scoped=true&ts=true"
import script from "./OpenHead.vue?vue&type=script&lang=ts"
export * from "./OpenHead.vue?vue&type=script&lang=ts"

import "./OpenHead.vue?vue&type=style&index=0&id=57e547bc&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57e547bc"]])

export default __exports__